module.exports = __webpack_public_path__ + "static/media/upload-arrow.8402d3fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_molecules/ImageInput/assets/upload-arrow.svg
// module id = 1207
// module chunks = 0